// extracted by mini-css-extract-plugin
module.exports = {"goBack":"BackTo_goBack__1cJEL","goBack2021":"BackTo_goBack2021__3g4E2"};